import { createContext } from 'react';
export const ContentstackClientContext = createContext({});
//# sourceMappingURL=contentstack-client-context.js.map